import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { ApiBaseUrl } from "../Config";
import { formatToDateTime } from "./main/formatToDateTime";

export default function ViewData({ type, date }) {
  const [Data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const GetData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${ApiBaseUrl}/warehouse/dashboard/view/jobs?type=${type}&date=${date}`
      );

      if (response.data && response.data.data) {
        setData(response.data.data);
      } else {
        setData([]);
        Swal.fire({
          icon: response.data.status,
          text: response.data.message,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, [type, date]);

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="w-100">
        <div className="row">
          <div className="card">
            <div className="card-body px-0">
              <div className="table-responsive text-nowrap">
                <table className="table table-striped  table-hover table-font">
                  <thead>
                    <tr class="table-primary">
                      <th>S.No.</th>
                      <th>Job Type</th>
                      <th>CTR No</th>
                      <th>CTR Size</th>
                      <th>CTR Type</th>
                      <th>Loaded/Empty</th>
                      <th>FCL/LCL</th>
                      <th>Source</th>
                      <th>JOB No</th>
                      <th>JOB Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Data &&
                      Data.map((data, i) => (
                        <tr key={i}>
                          <td>
                            <span> {i + 1}</span>
                          </td>
                          <td>
                            <span> {data.job_type}</span>
                          </td>
                          <td>
                            <span> {data.container_no}</span>
                          </td>
                          <td>
                            {data.container_size}
                          </td>
                          <td>
                            {data.container_type}
                          </td>
                          <td>
                            <span>
                              {data.ldd_mt_flg=='L'
                                ? "Loaded"
                                : "Empty"}
                            </span>
                          </td>

                          <td>
                            <span>
                              {data.flc_lcl_flg}
                            </span>
                          </td>
                          <td>
                            <span>
                              {data.icd_location}
                            </span>
                          </td>
                          <td>
                            <span>
                              {data.job_no}
                            </span>
                          </td>
                          <td>
                            <span>{formatToDateTime(data.job_date)} </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
